import { ModuleWithProviders, NgModule } from '@angular/core';
import { NoolaConfig } from './noola-config.service';
import { Noola } from './noola.service';

@NgModule({
  providers: [
    Noola,
    NoolaConfig
  ]
})
export class ZefNoolaModule {
  static forRoot(config: NoolaConfig): ModuleWithProviders<ZefNoolaModule> {
    return {
      ngModule: ZefNoolaModule,
      providers: [
        Noola,
        { provide: NoolaConfig, useValue: config }
      ]
    };
  }
}
